export interface OperatorOption {
  value: string;
  label: string;
  negated: boolean;
}

export const OPERATOR_OPTIONS: OperatorOption[] = [
  { value: 'contains', label: 'Contains', negated: false },
  { value: 'not_contains', label: 'Does Not contain', negated: true },
  { value: 'equals', label: 'Equals', negated: false },
  { value: 'not_equals', label: 'Does Not Equal', negated: true },
  { value: 'greater_than', label: 'Greater Than', negated: false },
  { value: 'less_than', label: 'Less Than', negated: false },
];

export const DEFAULT_OPERATOR = 'contains';

